import {ReduceStore} from 'flux/utils';
import Dispatcher from '../../dispatcher';
import {Filters} from '../../constants/filter/filters';
import {getDefaultValueForFilter} from '../../helper/filters/get_default_value_for_filter';
import {CatalogFilterStoreClass} from './base';

class CatalogWheelFilterStoreClass extends CatalogFilterStoreClass {
    getInitialState() {
        const initialState = {};

        initialState[Filters.MANUFACTURER] = getDefaultValueForFilter(Filters.MANUFACTURER);
        initialState[Filters.WHEEL_MODEL] = getDefaultValueForFilter(Filters.WHEEL_MODEL);
        initialState[Filters.WHEEL_DIAMETER] = getDefaultValueForFilter(Filters.WHEEL_DIAMETER);
        initialState[Filters.WHEEL_WIDTH] = getDefaultValueForFilter(Filters.WHEEL_WIDTH);
        initialState[Filters.WHEEL_STUDS] = getDefaultValueForFilter(Filters.WHEEL_STUDS);
        initialState[Filters.WHEEL_PCD] = getDefaultValueForFilter(Filters.WHEEL_PCD);
        initialState[Filters.WHEEL_FINISH] = getDefaultValueForFilter(Filters.WHEEL_FINISH);
        initialState[Filters.PRICE_MIN] = getDefaultValueForFilter(Filters.PRICE_MIN);
        initialState[Filters.PRICE_MAX] = getDefaultValueForFilter(Filters.PRICE_MAX);

        return initialState;
    }
}

const CatalogWheelFilterStore = new CatalogWheelFilterStoreClass(Dispatcher);
export default CatalogWheelFilterStore;
